<template>
  <!-- Use the 'clip-shadow' class on the root element here if you go with the clip-waves approach -->
  <div class="clip-shadow">
    <slot name="overflow"></slot>

    <clip-waves
      class="start-layer"
      :class="clipWavesClass"
      v-bind:style="{ background: clipWavesBackground }"
      pad-wave-height
      :offset="offset"
    >
      <slot></slot>
    </clip-waves>

    <!-- A low-complexity option -->
    <!--
    <div class="start-layer" :class="clipWavesClass" v-bind:style="{ background: clipWavesBackground }">
      <slot></slot>
    </div>
    -->

  </div>
</template>


<script>
import ClipWaves from '@/components/ClipWaves.vue';
import Parallax from '@/components/Parallax.vue';

export default {
  name: 'start-layer',
  components: { ClipWaves, Parallax },
  props: [ 'offset', 'clipWavesClass', 'clipWavesBackground' ]
};
</script>
